import { WizardContext } from 'react-albus';

const isFirstStep = (wizard: WizardContext) => wizard.step.id === wizard.steps[0]?.id;

export { isFirstStep };
